import type { ChatImageSlot } from './canvas-types';

/** One live stream owns one registry; repeated events cannot reserve another slot. */
export function createChatImageSlotRegistry() {
  const slots = new Map<string, number>();
  return {
    get: (taskId: string) => slots.get(taskId),
    claim(taskId: string): { index: number; isNew: boolean } {
      const existing = slots.get(taskId);
      if (existing !== undefined) return { index: existing, isNew: false };
      const index = slots.size;
      slots.set(taskId, index);
      return { index, isNew: true };
    },
  };
}

/** A delivered image supersedes an earlier failure for that same slot. */
export function resolveChatImageSlots(slots: ChatImageSlot[], index: number, url: string): ChatImageSlot[] {
  return slots.map(slot => slot.index === index
    ? { ...slot, resolved: url, failed: undefined, errorMsg: undefined }
    : slot);
}
